module.exports = __webpack_public_path__ + "assets/img/logitech-becomethenextcreator-w720.e4b0e114.webp";